const EMPTY_ASSESSMENT_REPORT: never[] = [];

export const teamAssessmentInitialSorting = [
  { id: 'displayName', desc: false },
];

export const schoolAssessmentInitialSorting = [{ id: 'name', desc: false }];

export function getAssessmentReportData<T extends unknown[]>(
  data: T | undefined,
): T {
  return data ?? (EMPTY_ASSESSMENT_REPORT as unknown as T);
}

export function getValidAssessmentOption<T extends number | string>(
  options: readonly { key: T }[],
  preferredValue: T,
  fallbackValue?: T,
): T {
  if (options.length === 0) return preferredValue;

  if (options.some(({ key }) => key === preferredValue)) return preferredValue;
  if (
    fallbackValue !== undefined &&
    options.some(({ key }) => key === fallbackValue)
  ) {
    return fallbackValue;
  }

  return options[0]!.key;
}
